var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
var MicrophoneServiceImpl = /** @class */ (function () {
    function MicrophoneServiceImpl() {
        var _this = this;
        this._initialized = false;
        this._fftSize = 1024;
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
            _this._audioContext = new AudioContext();
            _this._microphone = _this._audioContext.createMediaStreamSource(stream);
            _this._analyser = _this._audioContext.createAnalyser();
            _this._ui8a = new Uint8Array(_this._analyser.frequencyBinCount);
            _this._microphone.connect(_this._analyser);
            _this._initialized = true;
        }).catch(function (error) {
            console.error(error);
        });
    }
    Object.defineProperty(MicrophoneServiceImpl.prototype, "fftSize", {
        get: function () {
            return this._fftSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicrophoneServiceImpl.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicrophoneServiceImpl.prototype, "samples", {
        get: function () {
            if (this._analyser && this._ui8a) {
                this._analyser.getByteTimeDomainData(this._ui8a);
                return Array.from(this._ui8a).map(function (elem) { return elem / 128 - 1; });
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MicrophoneServiceImpl.prototype, "volume", {
        get: function () {
            if (this._analyser && this._ui8a) {
                this._analyser.getByteTimeDomainData(this._ui8a);
                var sum = this._ui8a.reduce(function (acc, elem) { return acc + Math.pow((elem / 128 - 1), 2); }, 0);
                return Math.sqrt(sum / this._ui8a.length);
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    MicrophoneServiceImpl = __decorate([
        injectable()
    ], MicrophoneServiceImpl);
    return MicrophoneServiceImpl;
}());
export { MicrophoneServiceImpl };
